import { get, postRaw } from '@Lib/request'
import { path } from './url'
import { IData, TabType, SchemeListType, BillListType, FilterBrandType, CreateListRowType, CheckBeforeItemType } from '@Components/member/effectiveAd/index.d'

const { usedCarApiV4, usedApi } = path

// 活動頁 - 物件瀏覽倍數
export function adactivityEffect() {
    return get<{
        list: any
    }>(`${usedCarApiV4}/adactivity/effect`)
}

// 活動頁 - 成交數據
export function adactivityDeal() {
    return get<{
        list: any
    }>(`${usedCarApiV4}/adactivity/deal`)
}

export function fetchAdBrand(params: {
    tab: TabType
  }) {
    return get<{
        brands: Array<{
            id: number
            name: string
            kinds: {
                id: number
                name: string 
            }[]
        }>
    }>(`${usedApi}/ad/member/brandKind`, params)
}

export function fetchAdsEffect() {
    return get<{
        ad: {
            click: {
                total: string
                yesterday: string
            }
            money: {
                total: string
            }
            show: {
                total: string
                yesterday: string
            }
        }
    }>(`${usedApi}/ad/member/adsEffect`)
}

export function fetchAdEffect() {
    return get<{
        ad: {
            click: string
            money: string
            name: string
            show: string
            showList: {
                date: string
                show: number
            }[]
        }[]
    }>(`${usedApi}/ad/member/adsItemEffect`)
}

export function fetchAdList(params: {
    tab: TabType
    brandId?: string
    kindId?: string
    itemId?: string
    page?: string
    pageSize?: string
}) {
    return get<IData>(`${usedApi}/ad/member/adList`, params)
}

export function invalidAd(id: number) {
    return postRaw(`${usedApi}/ad/member/unshow`, { id })
}

export function deleteAd(id: number) {
    return postRaw(`${usedApi}/ad/member/delete`, { id })
}

export function restartAd(id: number) {
    return postRaw<{
        id: number
        saleCOde: string
    }>(`${usedApi}/effectAd/member/restart`, { id })
}

export function fetchAdScheme(itemId: number) {
    return get<{
        list: SchemeListType[]
        item: {
            cover: string
        }
    }>(`${usedCarApiV4}/ad/member/adSlot`, { itemId })
}

export function fetchItemInfo(itemId: number) {
    return get<{
        cover: string
        showPrice: string
        subtitle: string
    }>(`${usedCarApiV4}/ad/member/itemInfo`, { itemId })
}

export function fetchAdPayInfo(id: number) {
    return get<{
        balance: number
        list: BillListType[]
    }>(`${usedCarApiV4}/ad/member/adPayInfo`, { id })
}

export function fetchFilterItem() {
    return get<{
        brand: FilterBrandType[],
        year: number[]
    }>(`${usedCarApiV4}/effectAd/member/items/filter`)
}

export function fetchAdItems(params) {
    return get<{
        list: CreateListRowType[],
        total: number
    }>(`${usedCarApiV4}/effectAd/member/items`, params)
}

export function saveAd(params) {
    return postRaw<{
        id: number
        saleCode: number
        content: string
    }>(`${usedCarApiV4}/ad/member/saveAd`, params)
}

export function fetchAdInfoById(id: number) {
    return get<{
        ad: {
            title: string
            saleCode: number
            imagePath: string
        }
        item: {
            cover: string
            itemId: number
        }
    }>(`${usedCarApiV4}/ad/member/adInfo`, { id })
}

export function adPayBeforeCheck(id: number) {
    return get<{
        tips: string
    }>(`${usedCarApiV4}/ad/member/adPayBeforeCheck`, { id })
}

export function adPay(data: {
    id: number
    couponId?: number
}) {
    return postRaw<{
        tips: string
        content?: string
    }>(`${usedCarApiV4}/ad/member/adPay`, data)
}

export function fetchEstimatedEffect(params: { itemId?: number; saleCode?: number }) {
    return get<{
        times: number
    }>(`${usedCarApiV4}/effectAd/member/items/estimatedEffect`, params)
}

export function adBuyBeforeCheck(itemId: number) {
    return get<CheckBeforeItemType>(`${usedCarApiV4}/effectAd/member/adBuyBeforeCheck`, { itemId })
}